module.exports = __webpack_public_path__ + "img/6.3cf1cd59.jpg";